module.exports = __webpack_public_path__ + "img/Logo2.fa627e50.png";